/* eslint-disable @next/next/no-img-element */
import React from 'react';
import {MenuItem, Select, SelectChangeEvent} from '@mui/material';
import SVGIcons from '@components/SVGIcon';
import {Image} from '@components/Image';
import {
  CountrySelectProps as Props,
  SelectIconProps,
  optionType,
} from './CountrySelect.type';
import cn from './CountrySelect.module.scss';
export function CountrySelect(props: Props) {
  const selectedOption = React.useMemo(() => {
    return getSelectedOption(props.options, props.value);
  }, [props.options, props.value]);

  const FlagImage = ({type}: {type: string}): JSX.Element => {
    const url = `http://purecatamphetamine.github.io/country-flag-icons/3x2/${type}.svg`;
    return <Image url={url} alt={type} width={17} />;
  };

  const renderValue = () => {
    if (selectedOption)
      return (
        <div className={cn.renderValue}>
          <FlagImage type={selectedOption.flagCode} />
          <span>{selectedOption.code}</span>
        </div>
      );
  };

  const onChangeSelection = (e: SelectChangeEvent) => {
    props.onChange(e.target.value);
  };
  return (
    <Select
      className={cn.countrySelectBlock}
      disabled={props.disabled}
      name={props.name}
      value={props.value}
      onChange={onChangeSelection}
      renderValue={renderValue}
      IconComponent={SelectIcon}
      inputProps={{
        'data-testid': 'lf_countryCode',
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: 250,
            maxWidth: 350,
            marginTop: '0rem',
          },
        },
      }}>
      {props.options.map((option: any) => (
        <MenuItem
          key={option.value}
          value={option.value}
          className={cn.selectOption}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const SelectIcon = (props: SelectIconProps) => (
  <span className={`${props.className} ${cn.selectIcon}`}>
    <SVGIcons type={'downarrow-svg'} />
  </span>
);

function getSelectedOption(options: optionType[], value: string) {
  for (const option of options) {
    if (option.value === value) {
      return option;
    }
  }
}
